import { render, staticRenderFns } from "./RiskhubVueElementLoading.vue?vue&type=template&id=61412343&"
import script from "./RiskhubVueElementLoading.vue?vue&type=script&lang=js&"
export * from "./RiskhubVueElementLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports